// Programmatic location pages — každá lokalita má unikátní logistiku, dopravu, doporučený formát a FAQ.
const BASE_FAQ_PRICE = {
  q: "Kolik teambuilding stojí?",
  a: "Balíček Mission 24 vychází orientačně od 4 990 Kč na osobu, minimální cena akce je 129 000 Kč. Jednodenní Mission bez noclehu od 2 490 Kč na osobu. Finální cena závisí na termínu a konfiguraci.",
};

const mk = (loc) => ({
  path: `/teambuilding-${loc.slug}`,
  type: "location",
  seo: {
    title: loc.title,
    description: loc.description,
    schema: ["Service", "BreadcrumbList"],
  },
  h1: loc.h1,
  breadcrumbs: [
    { label: "Úvod", href: "/" },
    { label: `Teambuilding ${loc.cityCZ}`, href: `/teambuilding-${loc.slug}` },
  ],
  blocks: [
    {
      t: "hero",
      overline: `TEAMBULDING PRO FIRMY · ${loc.cityUpper}`,
      title: loc.h1,
      sub: loc.heroSub,
      trust: ["20–50 lidí", "Ještěd", "ubytování", "soukromý klub", "jeden dodavatel"],
      primary: { label: loc.cta, href: "/poptavka" },
      secondary: { label: "Zobrazit program", href: "/jak-to-funguje" },
      price: "od 4 990 Kč / osoba",
      img: "heroArrival",
    },
    {
      t: "answer",
      q: loc.answerQ,
      short: loc.answerShort,
      paras: loc.answerDetail,
    },
    ...(loc.facts ? [{ t: "facts", items: loc.facts }] : []),
    {
      t: "section",
      kicker: "LOGISTIKA",
      heading: "Doprava a logistika",
      paras: loc.logistics,
      img: loc.logisticsImg || "mapTable",
    },
    {
      t: "section",
      kicker: "DOPORUČENÝ FORMÁT",
      heading: loc.formatHeading,
      paras: loc.format,
      img: loc.formatImg || "forestMission",
      reverse: true,
    },
    { t: "pricetable" },
    {
      t: "steps",
      kicker: "JAK TO PROBÍHÁ",
      heading: "Pět fází mise",
      items: [
        { k: "01", t: "ARRIVAL", d: "Příjezd do Warehouse Liberec, check-in, občerstvení." },
        { k: "02", t: "THE DROP", d: "Transport na start, Mission Pack, první instrukce." },
        { k: "03", t: "THE MISSION", d: "Orientace, checkpointy a týmové úkoly směrem k Ještědu." },
        { k: "04", t: "THE SUMMIT", d: "Finish, týmová fotografie, finish drink." },
        { k: "05", t: "WAREHOUSE", d: "Večeře, vyhlášení a soukromá party jen pro vás." },
      ],
    },
    { t: "faq", heading: "Časté otázky", items: [...loc.faq, BASE_FAQ_PRICE] },
    { t: "cta", heading: "Připravíme vám misi", text: "Stačí počet lidí, termín a rozpočet. Návrh mise je nezávazný." },
  ],
  related: loc.related,
});

export const LOCATIONS = [
  mk({
    slug: "praha",
    cityCZ: "Praha",
    cityUpper: "PRAHA",
    title: "Firemní teambuilding pro firmy z Prahy | Mission Ještěd",
    description: "Firemní teambuilding kousek od Prahy: dopolední odjezd od kanceláře, Mission Ještěd, večer soukromý Warehouse Liberec jen pro váš tým. Ubytování, doprava, jeden dodavatel.",
    h1: "Firemní teambuilding kousek od Prahy, na který lidé nezapomenou",
    heroSub: "Ráno vyjedete od kanceláře. Odpoledne váš tým plní Mission Ještěd. Večer máte celý Warehouse jen pro sebe.",
    cta: "Chci teambuilding pro firmu z Prahy",
    answerQ: "Proč jet na firemní teambuilding z Prahy do Liberce?",
    answerShort: "Protože za zhruba hodinu a půl cesty dostane váš tým něco, co Praha nenabídne: horu, misi s příběhem a industriální klub jen pro sebe — vše od jednoho dodavatele.",
    answerDetail: [
      "Mission Ještěd není další pražská escape room ani večeře v zámecké restauraci. Je to 24hodinová řízená týmová mise: účastníci předem neznají trasu ani úkoly a do cíle se dostanou jen jako tým.",
      "Dojezd z Prahy je orientačně 1–1,5 hodiny podle aktuální dopravy po dálnici D10. Přesný čas si ověřte před odjezdem — nebo nechte dopravu na nás.",
    ],
    facts: [
      ["Dojezd z Prahy", "orientačně 1–1,5 h (D10)"],
      ["Doprava", "autobus door-to-door od kanceláře"],
      ["Skupina", "20–50 lidí"],
      ["Délka", "24 hodin (Mission 24)"],
      ["Cena", "od 4 990 Kč / osoba"],
      ["Lokalita", "Liberec + Ještěd"],
    ],
    logistics: [
      "Vyzvedneme váš tým před kanceláří a zase ho tam vrátíme. Objednáme autobus na míru vaší skupině, řidič zná trasu i harmonogram mise — nemusíte řešit nic.",
      "Pokud jedete vlastními auty, doporučujeme odjezd z Prahy kolem 9:30, abyste byli ve Warehouse Liberec včas na check-in a briefing. Parkování je přímo u objektu.",
      "Typický časový příklad pro firmu z Prahy: 9:30 odjezd od kanceláře, 11:00 arrival ve Warehouse, 13:30 start mise, 17:00 finish na Ještědu, 19:30 večeře, 21:30 private party, druhý den 11:00 check-out a návrat do Prahy kolem oběda.",
    ],
    logisticsImg: "warehouseExterior",
    formatHeading: "Pro pražské firmy doporučujeme Mission 24",
    format: [
      "Z Prahy se nevyplatí jezdit na pár hodin. Mission 24 spojuje odpolední misi, večeři, soukromou party ve Warehouse, nocleh a snídani do jednoho balíčku — tým si odveze kompletní zážitek, ne jen výlet.",
      "Pro týmy, které chtějí víc, je tu Mission Weekend s druhým programem a dvěma noclehy. Pro rychlou akci bez noclehu jednodenní Mission — u ní z Prahy doporučujeme náš autobus, aby nikdo nemusel řídit zpět.",
    ],
    faq: [
      { q: "Zajistíte dopravu z Prahy?", a: "Ano. Objednáme autobus, který vyzvedne tým před vaší kanceláří a po check-outu ho vrátí zpět. Doprava je upsell k balíčku, cenu nabídneme v kalkulaci." },
      { q: "Jak dlouho trvá cesta z Prahy?", a: "Orientačně 1–1,5 hodiny po dálnici D10 podle aktuální dopravní situace. Přesný čas odjezdu sladíme s harmonogramem mise." },
      { q: "Stíháme to jako jednodenní akci z Prahy?", a: "Jednodenní Mission trvá 4–6 hodin, takže ano — s odjezdem ráno a návratem večer. Ale pražským firmám doporučujeme Mission 24: večerní party ve Warehouse a společná noc jsou to, co tým opravdu spojí." },
    ],
    related: [
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program 24hodinové mise." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny pro 20–50 lidí." },
      { href: "/teambuilding-s-dopravou", title: "Teambuilding s dopravou", text: "Door-to-door autobus od vaší kanceláře." },
      { href: "/teambuilding-s-ubytovanim", title: "Teambuilding s ubytováním", text: "Mise, nocleh a party v jednom." },
    ],
  }),
  mk({
    slug: "liberec",
    cityCZ: "Liberec",
    cityUpper: "LIBEREC",
    title: "Teambuilding v Liberci | Mission Ještěd & Warehouse Liberec",
    description: "Firemní teambuilding v Liberci přímo pod Ještědem. Mission Ještěd, soukromý Warehouse klub, ubytování — domácí hřiště, na kterém známe každou trasu.",
    h1: "Teambuilding v Liberci. Domácí hřiště, na kterém známe každou trasu.",
    heroSub: "Warehouse Liberec je naše základna. Ještěd je náš dvorek. Vaše firma je host, o kterého se postaráme od příjezdu do odjezdu.",
    cta: "Chci teambuilding v Liberci",
    answerQ: "Jak probíhá firemní teambuilding v Liberci?",
    answerShort: "Vaše firma dorazí do Warehouse Liberec, odtud organizovaně na start mise, na Ještěd a večer zpět do soukromého klubu. Liberečtí mají výhodu: všechno je u vás za rohem.",
    answerDetail: [
      "Mission Ještěd startuje z Warehouse na Hanychovské ulici, pár minut od libereckého centra. Checkpointy vedou Ještědským hřbetem — terén, který jezdíme a chodíme celý rok.",
      "Pro liberecké firmy je formát flexibilní: odpolední mise s večerní party, nebo klidně jen soukromý Warehouse večer po jednodenní misi bez ubytování.",
    ],
    logistics: [
      "Warehouse Liberec najdete na adrese Hanychovská 10, Liberec. Parkování je přímo u objektu, takže logistika pro liberecké firmy je otázka minut.",
      "Start mise řešíme organizovaným transportem — tým se nemusí o nic starat. Po finishi na Ještědu vás vezeme zpět do Warehouse na večeři a party.",
    ],
    formatHeading: "Libereckým firmám sedí každý formát",
    format: [
      "Jednodenní Mission bez noclehu dává smysl právě v Liberci — po večerním vyhlášení se každý dostane domů. Chcete-li ale plný zážitek, Mission 24 s noclehem a snídaní promění firemní akci ve společných 24 hodin.",
      "Pro liberecké týmy umíme i kratší after-work varianty Warehouse party s mini challengemi — napište nám, co potřebujete.",
    ],
    faq: [
      { q: "Jsme z Liberce — můžeme přijet až na briefing?", a: "Ano. Check-in a briefing je ve Warehouse na Hanychovské 10, takže stačí dorazit v domluvený čas. Vše ostatní organizujeme my." },
      { q: "Můžeme využít jen Warehouse na firemní party?", a: "Primárně prodáváme kompletní mise, ale pro liberecké firmy umíme připravit i večerní formát. Napište nám poptávku a domluvíme se." },
      { q: "Znáte trasy na Ještědu i v zimě?", a: "Ano. Mise má varianty pro jaro, léto, podzim i zimu, včetně weather planu. Obtížnost přizpůsobíme kondici týmu." },
    ],
    related: [
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program 24hodinové mise." },
      { href: "/warehouse-party", title: "Warehouse party", text: "Soukromý klub jen pro vaši firmu." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/jednodenni-teambuilding", title: "Jednodenní teambuilding", text: "Mise bez noclehu za 4–6 hodin." },
    ],
  }),
  mk({
    slug: "mlada-boleslav",
    cityCZ: "Mladá Boleslav",
    cityUpper: "MLADÁ BOLESLAV",
    title: "Teambuilding pro firmy z Mladé Boleslavi | Mission Ještěd",
    description: "Firemní teambuilding pro týmy z Mladé Boleslavi: Mission Ještěd s ubytováním a soukromou party ve Warehouse Liberec. Orientačně hodina cesty, kompletní servis.",
    h1: "Teambuilding pro firmy z Mladé Boleslavi, který má hlavu a patu",
    heroSub: "Z Boleslavi do Liberce je to orientačně hodina. Vaše firma ráno vyjede, odpoledne plní misi na Ještěd a večer má celý Warehouse jen pro sebe.",
    cta: "Chci teambuilding z Mladé Boleslavi",
    answerQ: "Jak probíhá teambuilding pro firmu z Mladé Boleslavi?",
    answerShort: "Autobus vyzvedne tým před vaší firmou, doveze ho do Warehouse Liberec a druhý den vrátí. O vše mezi tím se postaráme my — misi, jídlo, ubytování i party.",
    answerDetail: [
      "Z Mladé Boleslavi po dálnici D10 směr Liberec je to orientačně 50–70 minut podle dopravy. Ideální vzdálenost na to, aby cesta neunavila, ale tým opravdu vypnul mimo kancelář.",
      "Město automotive znamená týmy zvyklé na tempo a preciznost. Mission Ještěd testuje přesně to: rozhodování pod tlakem, komunikaci a spolupráci napříč rolemi.",
    ],
    logistics: [
      "Doporučujeme objednat náš autobus: vyzvednutí před firmou v Boleslavi kolem 9:30, check-in ve Warehouse v 11:00. Po akci vrátíme tým zpět před firmu.",
      "Pro vlastní dopravu je trasa přímočará po D10 a R35. Parkování u Warehouse je bez problémů i pro více aut.",
    ],
    formatHeading: "Z Boleslavi doporučujeme Mission 24",
    format: [
      "Hodinová cesta je přesně na hraně — jednodenní akce se dá stihnout, ale Mission 24 z ní udělá pořádný firemní zážitek: mise, večeře, soukromá party, nocleh a snídaně.",
      "Pro menší týmy 15–20 lidí máme stejný program s minimální cenou akce 129 000 Kč.",
    ],
    faq: [
      { q: "Jak daleko je to z Mladé Boleslavi?", a: "Orientačně 50–70 minut autem nebo autobusem po D10, podle aktuální dopravy. Náš autobus vyzvedne tým přímo před firmou." },
      { q: "Umíte zajistit výživu pro směnné provozy?", a: "Ano. Harmonogram mise umíme posunout tak, aby seděl směnám — včetně časů jídel a večerní party." },
      { q: "Máte zkušenost s výrobními firmami?", a: "Program stavíme pro smíšené týmy — od výroby přes logistiku po kancelář. Obtížnost i komunikaci přizpůsobíme složení skupiny." },
    ],
    related: [
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/teambuilding-praha", title: "Teambuilding Praha", text: "Pro firmy z Prahy včetně dopravy." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/teambuilding-pro-30-lidi", title: "Teambuilding pro 30 lidí", text: "Logistika a rozpočet pro 30 lidí." },
    ],
  }),
  mk({
    slug: "jablonec-nad-nisou",
    cityCZ: "Jablonec nad Nisou",
    cityUpper: "JABLONEC NAD NISOU",
    title: "Teambuilding pro firmy z Jablonce nad Nisou | Mission Ještěd",
    description: "Firemní teambuilding pro jablonecké firmy: Mission Ještěd je prakticky vaše domácí hora. Jednodenní mise i 24hodinový zážitek s Warehouse party.",
    h1: "Teambuilding z Jablonce? Ještěd je vaše domácí hora. My z ní uděláme misi.",
    heroSub: "Z Jablonce do Warehouse Liberec je to čtvrt hodiny. Váš tým ale uvidí Ještěd úplně jinak — s mapou, checkpointy a časovým limitem.",
    cta: "Chci teambuilding z Jablonce",
    answerQ: "Jak probíhá teambuilding pro jabloneckou firmu?",
    answerShort: "Přijedete do Warehouse Liberec, dostanete instrukce a Mission Pack, projdete si Ještěd jako týmovou misi a večer můžete slavit v soukromém klubu — domů je to kousek.",
    answerDetail: [
      "I když Ještěd znáte, misi ne. Trasu, checkpointy ani úkoly účastníci předem neznají — a právě to dělá z obyčejného výšlapu týmový zážitek.",
      "Jabloneckým firmám se nejvíc hodí jednodenní Mission nebo Mission 24 podle toho, jestli chcete večer pokračovat ve Warehouse.",
    ],
    logistics: [
      "Z Jablonce nad Nisou je do Warehouse Liberec orientačně 15–20 minut autem. Vlastní doprava je v tomto případě nejjednodušší, autobus zajistíme na přání.",
      "Po jednodenní misi bez noclehu se každý dostane domů do večera. Při Mission 24 zůstáváte přespat a ráno je v ceně snídaně.",
    ],
    formatHeading: "Pro Jablonec ideální jednodenní Mission",
    format: [
      "Díky vzdálenosti dává u jabloneckých firem smysl jednodenní Mission od 2 490 Kč na osobu — kompletní 4–6hodinová mise včetně organizace, transportu v místě, finish drinku a fotografií.",
      "Pokud chcete k misi večerní tečku, přidejte soukromý Warehouse s DJ a barem — z party je to do Jablonce stejně jen pár minut taxi.",
    ],
    faq: [
      { q: "Je to pro nás zajímavé, když Ještěd známe?", a: "Ano — právě proto. Mise promění známou horu v neznámý terén: checkpointy, úkoly a časový limit fungují i pro místní." },
      { q: "Lze akci stihnout odpoledne po práci?", a: "Pro jablonecké firmy umíme připravit zkrácenou odpolední variantu mise s večerním zakončením ve Warehouse. Napište nám termín a počet lidí." },
      { q: "Co když bude pršet?", a: "Mise má weather plan a varianty trasy. Extrémní je zážitek, ne riziko — program vždy přizpůsobíme počasí a kondici týmu." },
    ],
    related: [
      { href: "/jednodenni-teambuilding", title: "Jednodenní teambuilding", text: "Mise bez noclehu za 4–6 hodin." },
      { href: "/teambuilding-liberec", title: "Teambuilding Liberec", text: "Naše domácí základna." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
    ],
  }),
  mk({
    slug: "hradec-kralove",
    cityCZ: "Hradec Králové",
    cityUpper: "HRADEC KRÁLOVÉ",
    title: "Teambuilding pro firmy z Hradce Králové | Mission Ještěd",
    description: "Firemní teambuilding pro týmy z Hradce Králové: Mission Ještěd s dopravou, ubytováním a soukromou party ve Warehouse Liberec. Vše od jednoho dodavatele.",
    h1: "Firemní teambuilding z Hradce Králové: hodina a půl cesty za misí, která stojí za to",
    heroSub: "Autobus vyzvedne tým před firmou v Hradci. Odpoledne plníte Mission Ještěd, večer máte celý Warehouse Liberec jen pro sebe.",
    cta: "Chci teambuilding z Hradce Králové",
    answerQ: "Jak probíhá teambuilding pro firmu z Hradce Králové?",
    answerShort: "Z Hradce je to do Liberce orientačně hodina a půl. S naší dopravou o ničem nerozhodujete — tým ráno nastoupí a druhý den po snídani vystoupí zpátky před firmou.",
    answerDetail: [
      "Vzdálenost z Hradce Králové je přesně ta, kdy se vyplatí Mission 24: odpolední outdoorová mise, večeře, soukromá party ve Warehouse, nocleh a snídaně.",
      "Harmonogram je navržený tak, aby tým z Hradce vyrazil dopoledne a byl zpátky druhý den kolem oběda.",
    ],
    logistics: [
      "Doporučená trasa vede přes Jičín a Turnov, orientačně 1,5 hodiny podle dopravy. Náš autobus řeší cestu tam i zpět, včetně přesunů během akce.",
      "Check-in ve Warehouse v 11:00 znamená odjezd z Hradce kolem 9:15–9:30. Návrat druhý den po check-outu v 11:00.",
    ],
    formatHeading: "Z Hradce jednoznačně Mission 24 nebo Weekend",
    format: [
      "Při hodině a půl cesty nedává jednodenní formát smysl. Mission 24 (od 4 990 Kč/os., min. 129 000 Kč za akci) spojuje všechno, co teambuilding má být: misi, jídlo, party i společnou noc.",
      "Mission Weekend přidává druhý program a druhou noc — ideální pro firmy, které spojují teambuilding s ročním offsite.",
    ],
    faq: [
      { q: "Jak daleko je to z Hradce Králové?", a: "Orientačně 1,5 hodiny autobusem podle dopravy. Dopravu zajistíme na klíč — vyzvednutí i návrat před vaší firmou." },
      { q: "Zvládnete akci i pro 50 lidí?", a: "Ano, Mission 24 je navržená pro týmy 20–50 lidí. Pro 50 lidí je orientační cena 249 000 Kč včetně ubytování a party." },
      { q: "Můžeme akci spojit s firemním setkáním?", a: "Ano. Ráno nebo druhý den dopoledne umíme zajistit prostor pro interní program — napište to do poznámky v poptávce." },
    ],
    related: [
      { href: "/vikendovy-teambuilding", title: "Víkendový teambuilding", text: "Mission Weekend se dvěma noclehy." },
      { href: "/teambuilding-s-ubytovanim", title: "Teambuilding s ubytováním", text: "Mise, nocleh a party v jednom." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/teambuilding-pro-50-lidi", title: "Teambuilding pro 50 lidí", text: "Logistika a rozpočet pro 50 lidí." },
    ],
  }),
  mk({
    slug: "pardubice",
    cityCZ: "Pardubice",
    cityUpper: "PARDUBICE",
    title: "Teambuilding pro firmy z Pardubic | Mission Ještěd",
    description: "Firemní teambuilding pro týmy z Pardubic: Mission Ještěd s autobusem od kanceláře, ubytováním a soukromou Warehouse party. Jeden dodavatel, celá akce.",
    h1: "Teambuilding z Pardubic, kde firma řeší jediného dodavatele",
    heroSub: "Autobus od vaší kanceláře, Mission Ještěd, soukromý Warehouse Liberec na večer, nocleh a snídaně. Pardubice tam a zpět bez jediného starání.",
    cta: "Chci teambuilding z Pardubic",
    answerQ: "Jak probíhá teambuilding pro firmu z Pardubic?",
    answerShort: "Z Pardubic je to do Liberce orientačně hodina tři čtvrtě. S balíčkem Mission 24 a naším autobusem se o dopravu, program, jídlo, ubytování ani večer nemusíte starat.",
    answerDetail: [
      "Pardubické firmy typicky volí Mission 24: dopoledne odjezd, odpoledne mise na Ještěd, večer soukromá party ve Warehouse, druhý den snídaně a návrat.",
      "Pro větší týmy umíme zajistit více autobusů nebo kombinaci s vlastní dopravou — logistiku připravíme na míru.",
    ],
    logistics: [
      "Trasa vede přes Hradec Králové a Turnov, orientačně 1,75 hodiny podle dopravy. Náš autobus vyzvedne tým před kanceláří a vrátí ho tam po check-outu.",
      "Odjezd z Pardubic doporučujeme kolem 9:00. Harmonogram akce je nastavený tak, aby delší cesta nikde nestresovala.",
    ],
    formatHeading: "Pardubickým firmám doporučujeme Mission 24",
    format: [
      "Při této vzdálenosti je Mission 24 jasná volba: celá akce pod jedním dodavatelem, bez nocování po cestě, bez řešení restaurací a dopravy.",
      "Chcete-li tým vzít na delší offsite, Mission Weekend přidává druhý program, druhou noc a foto i video z celé akce.",
    ],
    faq: [
      { q: "Jak daleko je to z Pardubic?", a: "Orientačně 1,75 hodiny autobusem podle dopravy. Dopravu řešíme na klíč, včetně vyzvednutí před vaší kanceláří." },
      { q: "Kolik stojí akce pro 40 lidí?", a: "Mission 24 pro 40 lidí vychází orientačně na 209 000 Kč včetně ubytování, jídla, dopravy v místě a soukromé party." },
      { q: "Je program vhodný i pro nesportovce?", a: "Ano. Obtížnost mise má úrovně a program přizpůsobíme kondici týmu. Fyzickou část lze u jednotlivců vynechat bez vlivu na zážitek týmu." },
    ],
    related: [
      { href: "/teambuilding-s-dopravou", title: "Teambuilding s dopravou", text: "Door-to-door autobus od kanceláře." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/teambuilding-pro-40-lidi", title: "Teambuilding pro 40 lidí", text: "Logistika a rozpočet pro 40 lidí." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  }),
  mk({
    slug: "usti-nad-labem",
    cityCZ: "Ústí nad Labem",
    cityUpper: "ÚSTÍ NAD LABEM",
    title: "Teambuilding pro firmy z Ústí nad Labem | Mission Ještěd",
    description: "Firemní teambuilding pro týmy z Ústí nad Labem: Mission Ještěd s dopravou, ubytováním a soukromou party ve Warehouse Liberec. Orientačně hodinu a čtvrt cesty.",
    h1: "Firemní teambuilding z Ústí nad Labem na druhý konec severních Čech",
    heroSub: "Z Ústí po D8 a přes Lovosice je to do Liberce orientačně hodinu a čtvrt. Na místě přebíráme tým kompletně — mise, jídlo, nocleh, party.",
    cta: "Chci teambuilding z Ústí nad Labem",
    answerQ: "Jak probíhá teambuilding pro firmu z Ústí nad Labem?",
    answerShort: "Tým ráno nastoupí do našeho autobusu v Ústí, poobědvá ve Warehouse Liberec, odpoledne splní Mission Ještěd a večer má klub jen pro sebe. Druhý den po snídani zpět.",
    answerDetail: [
      "Mission Ještěd je kompletní 24hodinový firemní zážitek: řízená outdoorová mise s checkpointy, ubytování, večeře, snídaně a soukromá party ve Warehouse.",
      "Účastníci předem neznají trasu ani úkoly. Vědí jen termín — zbytek známe my.",
    ],
    logistics: [
      "Nejrychlejší trasa vede po dálnici D8 a přes Lovosice a Českou Lípu, orientačně 1,25 hodiny podle dopravy. Náš autobus vyzvedne tým kdekoliv v Ústí.",
      "Dopravu během akce (Warehouse → start → Ještěd → Warehouse) řešíme vlastním transportem, tým se o nic nestará.",
    ],
    formatHeading: "Pro Ústí doporučujeme Mission 24",
    format: [
      "Vzdálenost přes půl severních Čech volá po kompletním balíčku: Mission 24 od 4 990 Kč na osobu s noclehem, večeří, party a snídaní.",
      "Pro sezónní vrcholy (podzim, vánoční termíny) doporučujeme poptat s předstihem — soukromý Warehouse má kapacitu pro jednu firmu na večer.",
    ],
    faq: [
      { q: "Jak daleko je to z Ústí nad Labem?", a: "Orientačně 1,25 hodiny autobusem po D8 podle dopravy. Vyzvednutí i návrat zajistíme před vaší firmou." },
      { q: "Umíte zajistit akci ve všední den?", a: "Ano, mise běží ve všední dny i o víkendech. Ve všední den bývá snazší kapacita ubytování i Warehouse." },
      { q: "Co je v ceně balíčku Mission 24?", a: "Mission Ještěd, 1 noc, doprava v místě, lunch/snack, finish drink, večeře, soukromý Warehouse, DJ, fotograf a snídaně." },
    ],
    related: [
      { href: "/teambuilding-s-dopravou", title: "Teambuilding s dopravou", text: "Door-to-door autobus od kanceláře." },
      { href: "/teambuilding-decin", title: "Teambuilding Děčín", text: "Pro firmy z Děčína." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/bezpecnost", title: "Bezpečnost", text: "Extreme experience, safe execution." },
    ],
  }),
  mk({
    slug: "decin",
    cityCZ: "Děčín",
    cityUpper: "DĚČÍN",
    title: "Teambuilding pro firmy z Děčína | Mission Ještěd",
    description: "Firemní teambuilding pro týmy z Děčína: Mission Ještěd s autobusem, ubytováním a soukromou Warehouse party. Horský terén, který děčínským sedne.",
    h1: "Teambuilding z Děčína: z jednoho pohoří do druhého, ale úplně jinak",
    heroSub: "Děčínské týmy znají hory. Mission Ještěd ale není výšlap — je to mise s mapou, checkpointy a časovým limitem, zakončená privátní party ve Warehouse.",
    cta: "Chci teambuilding z Děčína",
    answerQ: "Jak probíhá teambuilding pro firmu z Děčína?",
    answerShort: "Z Děčína je to do Liberce orientačně hodinu a čtvrt přes Českou Lípu. Náš autobus vyzvedne tým před firmou a po akci ho vrátí zpět.",
    answerDetail: [
      "Týmy z Děčína bývají zvyklé na terén — proto jim Mission Ještěd sedne. Skóre ale netvoří jen čas: 40 % tvoří splněné úkoly a 20 % týmová spolupráce hodnocená instruktory.",
      "Nejrychlejší jednotlivec nevyhrává. Vyhrává tým, který funguje společně — od prvního checkpointu po finish na Ještědu.",
    ],
    logistics: [
      "Trasa z Děčína vede přes Českou Lípu, orientačně 1,25 hodiny podle dopravy. Náš autobus řeší cestu tam i zpět i všechny přesuny během akce.",
      "Odjezd z Děčína doporučujeme kolem 9:30, check-in ve Warehouse je v 11:00. Návrat druhý den po check-outu.",
    ],
    formatHeading: "Děčínským firmám doporučujeme Mission 24",
    format: [
      "Kompletní balíček s noclehem dává při této vzdálenosti největší smysl: mise, večeře, soukromá party, snídaně a žádné starosti s dopravou.",
      "Pro sportovnější týmy umíme navýšit obtížnost trasy a přidat bonusové challenge — řekněte nám, jaká je kondice týmu.",
    ],
    faq: [
      { q: "Jak daleko je to z Děčína?", a: "Orientačně 1,25 hodiny přes Českou Lípu. Autobus vyzvedne tým před vaší firmou a po akci ho tam vrátí." },
      { q: "Jsme sportovní tým — bude mise dost těžká?", a: "Obtížnost má úrovně. Pro kondiční týmy připravíme náročnější variantu trasy a bonusové výzvy. Skóre ale stejně rozhoduje hlavně spolupráce." },
      { q: "Lze misi kombinovat s výletem po okolí?", a: "Ano, v rámci Mission Weekend umíme druhý program postavit na míru — třeba okruh Ještědským hřbetem. Napište nám představu." },
    ],
    related: [
      { href: "/teambuilding-usti-nad-labem", title: "Teambuilding Ústí nad Labem", text: "Pro firmy z Ústí nad Labem." },
      { href: "/adrenalinovy-teambuilding", title: "Adrenalinový teambuilding", text: "Časový tlak, rozhodování, akce." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  }),
  mk({
    slug: "turnov",
    cityCZ: "Turnov",
    cityUpper: "TURNOV",
    title: "Teambuilding pro firmy z Turnova | Mission Ještěd",
    description: "Firemní teambuilding pro týmy z Turnova: Mission Ještěd je půl hodiny od vás. Jednodenní mise i 24hodinový zážitek se soukromou Warehouse party.",
    h1: "Teambuilding z Turnova: Ještěd za půl hodiny, zážitek na celý rok",
    heroSub: "Z Turnova do Warehouse Liberec je to orientačně 25–30 minut. Mission Ještěd promění vaši regionální horu v týmovou misi, kterou nikdo nečekal.",
    cta: "Chci teambuilding z Turnova",
    answerQ: "Jak probíhá teambuilding pro firmu z Turnova?",
    answerShort: "Přijedete do Warehouse Liberec, dostanete Mission Pack a instrukce, splníte misi na Ještědu a večer můžete slavit v soukromém klubu. Domů je to kousek.",
    answerDetail: [
      "Turnov je branou Českého ráje — vaše lidi ale vezmeme opačným směrem, na Ještěd. Mise s checkpointy a časovým limitem funguje i pro ty, kdo region znají.",
      "Díky krátké vzdálenosti můžete zvolit jednodenní Mission bez noclehu, nebo plných 24 hodin s party a snídaní.",
    ],
    logistics: [
      "Z Turnova do Warehouse Liberec je to orientačně 25–30 minut autem. Vlastní doprava je nejjednodušší, autobus zajistíme na přání.",
      "Parkování přímo u Warehouse. Po jednodenní misi bez noclehu je tým domů ještě ten večer.",
    ],
    formatHeading: "Turnovským firmám sedí jednodenní Mission i Mission 24",
    format: [
      "Jednodenní Mission od 2 490 Kč na osobu: 4–6 hodin, kompletní organizace, Mission Pack, checkpointy, finish drink a fotografie.",
      "Chcete-li z akce udělat pořádný firemní večer, Mission 24 přidává večeři, soukromý Warehouse s DJ, nocleh a snídani.",
    ],
    faq: [
      { q: "Je Mission Ještěd vhodná i pro menší firmu?", a: "Ano. Minimální cena akce Mission 24 je 129 000 Kč, jednodenní Mission umíme i pro menší skupiny — napište nám počet lidí." },
      { q: "Můžeme po misi rovnou domů?", a: "U jednodenní Mission ano. U Mission 24 je součástí nocleh a snídaně, ale program umíme přizpůsobit." },
      { q: "Znáte v regionu i jiné trasy než Ještěd?", a: "Mise je koncipovaná na Ještědský hřbet s finishi na Ještědu. Pro opakované akce umíme varianty checkpointů, aby mise překvapila i podruhé." },
    ],
    related: [
      { href: "/jednodenni-teambuilding", title: "Jednodenní teambuilding", text: "Mise bez noclehu za 4–6 hodin." },
      { href: "/teambuilding-liberec", title: "Teambuilding Liberec", text: "Naše domácí základna." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  }),
  mk({
    slug: "ceska-lipa",
    cityCZ: "Česká Lípa",
    cityUpper: "ČESKÁ LÍPA",
    title: "Teambuilding pro firmy z České Lípy | Mission Ještěd",
    description: "Firemní teambuilding pro týmy z České Lípy: Mission Ještěd je orientačně 40 minut cesty. Jednodenní mise i Mission 24 s ubytováním a soukromou Warehouse party.",
    h1: "Teambuilding z České Lípy: Ještěd za chvíli, zážitek na rok",
    heroSub: "Z České Lípy do Warehouse Liberec je to orientačně 40 minut. Vaše firma může dopoledne pracovat a odpoledne plnit misi — nebo si vzít plných 24 hodin s party a noclehem.",
    cta: "Chci teambuilding z České Lípy",
    answerQ: "Jak probíhá teambuilding pro firmu z České Lípy?",
    answerShort: "Přijedete do Warehouse Liberec, dostanete Mission Pack a instrukce, odpoledne splníte misi na Ještědu a večer můžete slavit v soukromém klubu. Domů je to kousek — nebo zůstanete přenocovat.",
    answerDetail: [
      "Česká Lípa je z našich lokalit nejblíž Ještědu — ideální pro jednodenní Mission bez noclehu i pro Mission 24 s večerní party.",
      "Účastníci předem neznají trasu ani úkoly. I když Ještěd znáte, misi ne: checkpointy a časový limit promění známou horu v nový zážitek.",
    ],
    logistics: [
      "Z České Lípy do Warehouse Liberec (Hanychovská 10) je to orientačně 40 minut autem. Vlastní doprava je nejjednodušší, autobus pro skupinu zajistíme na přání.",
      "Parkování přímo u Warehouse. Přesuny během akce (Warehouse → start → Ještěd → Warehouse) řeší náš organizovaný transport.",
    ],
    formatHeading: "Z České Lípy: jednodenní Mission nebo plných 24 hodin",
    format: [
      "Jednodenní Mission od 2 490 Kč na osobu: 4–6 hodin, kompletní organizace, Mission Pack, checkpointy, finish drink a fotografie. Ideální jako odpolední program po pracovním dopoledni.",
      "Chcete-li večerní tečku, Mission 24 přidává večeři, soukromý Warehouse s DJ, nocleh a snídani — z party je to do České Lípy zpět jen kousek.",
    ],
    faq: [
      { q: "Jak daleko je to z České Lípy?", a: "Orientačně 40 minut autem podle dopravy. Pro skupinu umíme zajistit i autobus, ale vlastní doprava je v této vzdálenosti nejjednodušší." },
      { q: "Dá se mise stihnout jako odpolední akce po práci?", a: "Pro firmy z blízkého okolí umíme připravit zkrácenou odpolední variantu s večerním zakončením ve Warehouse. Napište nám termín a počet lidí." },
      { q: "Je program vhodný i pro smíšený tým?", a: "Ano. Obtížnost mise má úrovně a program přizpůsobíme kondici týmu. Rozhoduje spolupráce, ne fyzická výkonnost." },
    ],
    related: [
      { href: "/jednodenni-teambuilding", title: "Jednodenní teambuilding", text: "Mise bez noclehu za 4–6 hodin." },
      { href: "/teambuilding-decin", title: "Teambuilding Děčín", text: "Pro firmy z Děčína." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  }),
  mk({
    slug: "teplice",
    cityCZ: "Teplice",
    cityUpper: "TEPLICE",
    title: "Teambuilding pro firmy z Teplic | Mission Ještěd",
    description: "Firemní teambuilding pro týmy z Teplic: Mission Ještěd s autobusem od kanceláře, ubytováním a soukromou Warehouse party. Orientačně hodinu a půl cesty.",
    h1: "Firemní teambuilding z Teplic na Ještěd: mise, nocleh, soukromá party",
    heroSub: "Z Teplic přes Ústí a Českou Lípu je to orientačně hodinu a půl. Náš autobus vyzvedne tým před firmou — a druhý den ho po snídani vrátí zpět.",
    cta: "Chci teambuilding z Teplic",
    answerQ: "Jak probíhá teambuilding pro firmu z Teplic?",
    answerShort: "Autobus vyzvedne tým v Teplicích, doveze ho do Warehouse Liberec, odpoledne proběhne Mission Ještěd, večer máte soukromý klub jen pro sebe a druhý den po snídani jedete zpět.",
    answerDetail: [
      "Při hodině a půl cesty dává smysl Mission 24: odpolední mise, večeře, party, nocleh a snídaně v jednom balíčku od 4 990 Kč na osobu (min. 129 000 Kč za akci).",
      "O dopravu se nemusíte starat — objednáme autobus na míru skupině a řidič zná harmonogram mise.",
    ],
    logistics: [
      "Doporučená trasa z Teplic vede přes Ústí nad Labem a Českou Lípu, orientačně 1,5 hodiny podle dopravy. Odjezd doporučujeme kolem 9:15, check-in ve Warehouse je v 11:00.",
      "Všechny přesuny během akce řešíme vlastním transportem. Po check-outu v 11:00 druhý den vás autobus vrátí zpět do Teplic kolem oběda.",
    ],
    formatHeading: "Pro Teplice doporučujeme Mission 24",
    format: [
      "Mission 24 spojuje misi, jídlo, soukromou party i nocleh pod jednoho dodavatele — při této vzdálenosti se jednodenní formát nevyplatí.",
      "Pro větší týmy (40–50 lidí) orientačně 209 000–249 000 Kč za akci včetně ubytování, večeře, party, fotografa a snídaně.",
    ],
    faq: [
      { q: "Jak daleko je to z Teplic?", a: "Orientačně 1,5 hodiny autobusem podle aktuální dopravy. Dopravu zajistíme na klíč — vyzvednutí i návrat před vaší firmou." },
      { q: "Zvládnete dopravu pro 50 lidí?", a: "Ano. Pro větší skupiny objednáváme větší autobus nebo kombinaci vozů. Cenu dopravy nabídneme v rámci kalkulace." },
      { q: "Co když bude pršet?", a: "Mise má weather plan: varianty trasy, kryté checkpointy a indoor backup ve Warehouse. Akce se neruší — přizpůsobí se." },
    ],
    related: [
      { href: "/teambuilding-usti-nad-labem", title: "Teambuilding Ústí nad Labem", text: "Pro firmy z Ústí nad Labem." },
      { href: "/teambuilding-s-dopravou", title: "Teambuilding s dopravou", text: "Door-to-door autobus od kanceláře." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  }),
];
